import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {PDFDownloadLink, PDFViewer} from "@react-pdf/renderer";
import ButtonAddIngredients from "./ButtonAddIngredients";
import TemporaryDrawer from "./Drawer";
import Comment from "./Comment";
import RateSlider from "./RateSlider";
import {PdfDocument} from "./PdfDocument";
import {Menu, Grid, Button, Typography, Fade} from '@material-ui/core';
import Star from '@material-ui/icons/Star';
import CommentIcon from "@material-ui/icons/Comment";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import GetApp from "@material-ui/icons/GetApp";
import FindInPage from "@material-ui/icons/FindInPage";


const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));


const useStyles = makeStyles((theme) => ({
    margin:{
        margin : 10
    }
}));


/**
 * This function will display a menu on click on the MoreVertIcon button,
 * the menu propose to add recipe's ingredients in user's grocery list, add comment,
 * add rate and view a pdf of recipe's preparation
 * @param recipe            {object} :  recipe's data
 * @param recipeIngredients {object} :  recipe ingredients' name and quantity
 * @return {*}
 * @constructor
 */
export default function MenuRecipe({recipe, recipeIngredients}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = useStyles();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Grid>
            <Button aria-controls="customized-menu" aria-haspopup="true"
                variant="contained" onClick={handleClick}
            >
                <MoreVertIcon/>
            </Button>
            <StyledMenu
                id="customized-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                    {<TemporaryDrawer recipeName={recipe.name}
                                      menuItem={
                                          <Grid container justify="flex-start" alignItems="center" >
                                              <CommentIcon/><Typography className={classes.margin}>Commenter</Typography>
                                          </Grid>}
                                      component={<Comment recipeName={recipe.name}/>}
                    />}
                    {<TemporaryDrawer recipeName={recipe.name}
                                      menuItem={
                                          <Grid container justify="flex-start" alignItems="center" >
                                              <Star/><Typography className={classes.margin}>Noter</Typography>
                                          </Grid>}
                                      component={<RateSlider recipeName={recipe.name}/>}
                    />}

                    {<TemporaryDrawer recipeName={recipe.name}
                                      menuItem={
                                          <Grid container justify="flex-start" alignItems="center" >
                                              <FindInPage/><Typography className={classes.margin}>Voir PDF</Typography>
                                          </Grid>}
                                      component={<Grid container justify="center">
                                          <PDFViewer style={{flex:1, height:"100vh"}}>
                                              <PdfDocument steps={recipe.steps_preparation} image={recipe.image} title={recipe.name} ingredients={recipeIngredients}/>
                                          </PDFViewer></Grid>}
                    />}

                    <PDFDownloadLink document={<PdfDocument steps={recipe.steps_preparation} image={recipe.image} title={recipe.name} ingredients={recipeIngredients}/>}
                                    fileName={recipe.name+".pdf"} style={{width:"100%", flex:1}}>
                      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :
                          <Button style={{width:"100%", flex:1, display:"flex", justifyContent:"flex-start"}}><GetApp/><Typography className={classes.margin}>PDF</Typography></Button>)}
                    </PDFDownloadLink>

                    <ButtonAddIngredients recipe={recipe} recipeIngredients={recipeIngredients} typoClass={classes.margin}/>

                </Grid>
            </StyledMenu>
        </Grid>
    );
}
